// extracted by mini-css-extract-plugin
export default {"colorPickerField":"styles_colorPickerField__9Xn0Z"};